import './src/index.css'

export { wrapPageElement } from './src/wrapWithElement'
